import React, { useEffect, useState } from "react"
import "./index.scss"
import { RichText } from "prismic-reactjs"
import { connect } from "react-redux"
import { HIDE_COOKIES } from "../../state/constants"

export const CookiesBar = connect(state => state.app.loaderState)(({ data, onClick, ...props }) => {

  const [cookiesVisible, setCookiesVisible] = useState(false)

  const getCookies = () => {
    if (typeof localStorage !== "undefined") {
      const cookies = localStorage.getItem("consent")
      if (!cookies) {
        setCookiesVisible(true)
      } else {
        props.dispatch({ type: HIDE_COOKIES })
      }
    }
  }

  const agreeToCookies = () => {
    if (typeof localStorage !== "undefined") {
      localStorage.setItem("consent", "heidi-cookie-consent")
      setCookiesVisible(false)
      props.dispatch({ type: HIDE_COOKIES })
    }
  }

  useEffect(() => {
    getCookies()
  }, [])

  return <div>
    {cookiesVisible &&
    <div className="app-cookies-bar d-flex align-items-center">
      <div className="container">
        <div className="d-flex justify-content-center align-items-center">
          {data.cookie_consent_text && data.cookie_consent_text[0] &&
          RichText.render(data.cookie_consent_text)
          }
          {data.cookie_consent_link && data.cookie_consent_link.url && data.cookie_consent_link_text &&
          <a href={data.cookie_consent_link.url} target="_blank">{data.cookie_consent_link_text}</a>
          }
          <div className="ok-button" onClick={agreeToCookies}>{data.cookie_consent_button_text ? data.cookie_consent_button_text : "OK"}</div>
        </div>
      </div>
    </div>
    }
  </div>
})
